import React, { createContext, useContext, useState, useEffect } from 'react';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [profileImage, setProfileImageState] = useState("./images/profile-green-dummy.svg");

    useEffect(() => {
        const storedImage = localStorage.getItem('userProfileImage');
        if (storedImage) {
            setProfileImageState(storedImage);
        }
    }, []);

    const setProfileImage = (newImage) => {
        setProfileImageState(newImage);
        localStorage.setItem('userProfileImage', newImage);
    };

    return (
        <UserContext.Provider value={{ profileImage, setProfileImage }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => useContext(UserContext);
